export default __webpack_public_path__ + "static/media/rapidapi.7ccc7699.svg";